import axios from 'axios'
import { ElMessage } from 'element-plus'
import cookie from '@/utils/cookies'
import config from '@/config/index'
import { clearSession, setSession } from '@/utils/storage'
import { useUserStore } from '@/stores/user'

let serverUrl = ''
// 允许未登录访问的页面：token 失效时不跳登录
const writePath = [
  '/',
  '/course/list',
  '/course/video',
  '/course/audio',
  '/course/graphic',
  '/course/live',
  '/course/subject',
  '/course/topic',
  '/entrancetest',
]

const isGuestAllowPath = (pathname) => {
  return writePath.some((p) => pathname === p || pathname.startsWith(p + '/'))
}

const createHttp = () => {
  const options = {
    timeout: 60000
  }
  const head = {}
  
  // 需要全路径才能工作
  if (process.server) {
    const nuxtApp = useNuxtApp()
    if (nuxtApp && nuxtApp.ssrContext.event && nuxtApp.ssrContext.event.req) {
      const cookieData = cookie.getInServer(nuxtApp.ssrContext.event.req)
      if (cookieData[config.tokenName]) {
        head.token = cookieData[config.tokenName]
      }
      if (cookieData.shopId) {
        head.sid = cookieData.shopId
      }
    }
    
    // 服务端渲染时，统一使用配置的baseURL
    options.baseURL = config.baseUrl
  }

  if (process.client) {
    const { removeToken } = useUserStore()
    // 客户端统一使用相对路径，通过nginx代理
    options.baseURL = '/gateway'
    if (cookie.getInClient(config.tokenName)) {
      head.token = cookie.getInClient(config.tokenName)
    } else {
      removeToken()
    }
    head.sid = cookie.getInClient('shopId')
    //  head.sid = '1871394163223760897'  // 湖南科技大学统考平台
    // head.sid = '1890324939742978049'  重庆理工大学演示  安徽财经大学
    // head.sid = '1686181461997211650' // 易甄学
    // head.sid = '1906897262520352770' // 高校研修班演示平台
  }
  if (!head.sid) {
    // 没有店铺ID时提示，不请求服务
    // 注意：业务侧一律 req().get/post，须直接返回带方法的 stub，不能再包一层 function
    if (process.client) {
      ElMessage.error('店铺不存在')
    }
    const rejectNoShop = () => Promise.reject(new Error('店铺不存在'))
    return {
      get: rejectNoShop,
      post: rejectNoShop,
      put: rejectNoShop,
      delete: rejectNoShop,
      request: rejectNoShop,
    }
  }
  options.headers = head
  // 添加请求拦截器
  const http = axios.create(options)
  http.interceptors.request.use(function (config) {
    serverUrl = config.url
    return config
  }, function (error) {
    // 对请求错误做些什么
    if (process.client) {
      return Promise.reject(error)
    }
  })
  http.interceptors.response.use(function (response) {
    if (response.config.url.indexOf('/base/api/wx/op/bind/authorization/info') > -1) {
      return Promise.resolve(response.data)
    }
    // 请求登录接口完成后更新token 过期时间
    if (serverUrl.indexOf('auth') != -1 && process.client) {
      const NowTime = new Date()
      NowTime.setTime((NowTime.getTime()) + config.tokenExpires)
      cookie.setInClient({ key: config.tokenName, val: cookie.getInClient(config.tokenName), expires: NowTime })
    }

    if (response.config.data || response.config.params) {
      let d = response.config.data || response.config.params
      if (typeof d === 'string') {
        try {
          d = JSON.parse(d)
        } catch (err) { }
      }
      if (d._No_dispose) {
        return Promise.resolve(response.data)
      }
    }


    if (response.headers["content-type"] == "application/octet-stream" || response.headers["content-type"] == "application/pdf" || response.responseType ===  'blob' || response.request.responseType ===  'arraybuffer') {
      return response.data
    }

    // 对响应数据做点什么
    if (response.data.code === 200) {
      return Promise.resolve(response.data.data || response.data)
    } else {
      // console.info('request to: ' + serverUrl)
      // console.warn(JSON.stringify(response.data))
      if (response.data.code >= 300 && response.data.code <= 400 && response.data.code !== 321) {
        if (process.client) { // 客户端请求接口token 过期让他重新登录
          // ElMessage.error(response.data.msg)
          setSession('userInfo', '')
          clearSession()
          const { removeToken } = useUserStore()
          removeToken()
          if (!isGuestAllowPath(window.location.pathname)) {
            const _route = window.location.pathname + window.location.search
            window.location.href = '/login?redirect=' + encodeURIComponent(_route)
          }
          return Promise.reject(response.data)
        } else {
          // console.info(JSON.stringify(response.data.data || response.data))
        }
      }

      if (process.client) {
        // console.info(JSON.stringify(response.data.data || response.data))
        let d = null
        try {
          d = (response.config.data && JSON.parse(response.config.data)) || response.config.params
        } catch (e) {
          d = response.config.params
        }
        if (!d || d.isShowErrTip !== false) {
          // 过滤同时多个接口报token错误 会出现多个提示bug
          const title = localStorage.getItem('___errmsg')
          const time = localStorage.getItem('___errmsgTime')
          const newtime = (new Date()).getTime()
          if (title !== response.data.msg || (newtime - time) > 2000) {
            localStorage.setItem('___errmsg', response.data.msg)
            localStorage.setItem('___errmsgTime', newtime)
            if(response.data.msg === '') return
            ElMessage.error(response.data.msg)
          }
          return Promise.reject(response.data.data || response.data)
        } else {
          return Promise.resolve(response.data.data || response.data)
        }
      } else {
        return Promise.resolve(response.data.data || response.data)
      }
    }
  }, function (error) {
    // 对响应错误做点什么
    console.error('request to: ' ,error)
    // 培训播放进度上报失败常见于代理中断/请求取消，无 HTTP status；不弹红字打扰看课
    const reqUrl = (error && error.config && error.config.url) || ''
    const silentNetwork =
      reqUrl.indexOf('/train/play/event') > -1 ||
      reqUrl.indexOf('/resource/auth/course/save') > -1
    if (!silentNetwork && process.client) {
      ElMessage.error(error.message || 'Network Error')
    }
    if (process.client) {
      return Promise.reject(error)
    } else {
      // console.info('request to: ' + serverUrl)
      // console.info(JSON.stringify(error))
      return Promise.resolve(error.response && error.response.data)
    }
  })
  return http
}

export default createHttp
